var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("box", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("h4", [
                  _c("i", { staticClass: "fas fa-list" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.resource("JourneyComposer_Overview_Active_Header")
                      ) +
                      "\n            "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c("a", { attrs: { href: _vm.journeyStatisticsUrl } }, [
                      _c(
                        "button",
                        { staticClass: "btn btn-outline-secondary pull-left" },
                        [
                          _c("i", { staticClass: "fas fa-chart-area" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.resource(
                                  "JourneyComposer_Overview_JourneyReport_Button"
                                )
                              ) +
                              "\n                        "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _vm.hasWritePermission
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary pull-right",
                            on: { click: _vm.newJourney }
                          },
                          [
                            _c("i", { staticClass: "fas fa-plus" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.resource(
                                    "JourneyComposer_Overview_NewJourney_Button"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("ExpandableDataTable", {
                  staticClass: "table table-striped",
                  attrs: {
                    items: _vm.activeJourneys,
                    headers: _vm.headers,
                    focusFilterOnLoad: true
                  },
                  on: {
                    clone: function($event) {
                      return _vm.prepareClone($event.id)
                    },
                    delete: function($event) {
                      return _vm.prepareDelete($event.id)
                    },
                    edit: function($event) {
                      return _vm.handleEdit($event.id)
                    },
                    statistics: function($event) {
                      return _vm.navigateToStatistics($event.id)
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("box", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("h4", [
                  _c("i", { staticClass: "fas fa-list" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.resource("JourneyComposer_Overview_Inactive_Header")
                      ) +
                      "\n            "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c("ExpandableDataTable", {
                  staticClass: "table table-striped",
                  attrs: { items: _vm.inactiveJourneys, headers: _vm.headers },
                  on: {
                    clone: function($event) {
                      return _vm.prepareClone($event.id)
                    },
                    delete: function($event) {
                      return _vm.prepareDelete($event.id)
                    },
                    edit: function($event) {
                      return _vm.handleEdit($event.id)
                    },
                    statistics: function($event) {
                      return _vm.navigateToStatistics($event.id)
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.showPrompt
        ? _c("prompt", {
            attrs: {
              title: _vm.promptTitle,
              body: _vm.promptBody,
              size: _vm.promptsize,
              icon: _vm.promptIcon
            },
            on: {
              yes: _vm.promptHandler,
              hidden: function($event) {
                _vm.showPrompt = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }